// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as TerminalRouteImport } from './routes/_terminal'
import { Route as TerminalAdminRouteImport } from './routes/_terminalAdmin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MethodologyRouteImport } from './routes/methodology'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminAdminRouteImport } from './routes/_admin/admin'
import { Route as TerminalTerminalRouteImport } from './routes/_terminal/terminal'
import { Route as TerminalLoginRouteImport } from './routes/terminal/login'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin/admin/index'
import { Route as AdminAdminCreateUserRouteImport } from './routes/_admin/admin/create-user'
import { Route as AdminAdminMonitoringRouteImport } from './routes/_admin/admin/monitoring'
import { Route as AdminAdminStyleRouteImport } from './routes/_admin/admin/style'
import { Route as TerminalTerminalIndexRouteImport } from './routes/_terminal/terminal/index'
import { Route as TerminalTerminalSlugRouteImport } from './routes/_terminal/terminal/$slug'
import { Route as TerminalTerminalDefinitionsRouteImport } from './routes/_terminal/terminal/definitions'
import { Route as TerminalTerminalPolicy20RouteImport } from './routes/_terminal/terminal/policy-2-0'
import { Route as TerminalTerminalRequestsRouteImport } from './routes/_terminal/terminal/requests'
import { Route as CompanyLongSlugIndexRouteImport } from './routes/company.$longSlug/index'
import { Route as CompanyLongSlugContactRouteImport } from './routes/company.$longSlug/contact'
import { Route as TerminalAuthCallbackRouteImport } from './routes/terminal/auth/callback'
import { Route as AdminAdminIndividualsIndividualIdRouteImport } from './routes/_admin/admin/individuals.$individualId'
import { Route as AdminAdminMonitoringCompanyRunIdRouteImport } from './routes/_admin/admin/monitoring_.$companyRunId'
import { Route as TerminalAdminTerminalAdminIndexRouteImport } from './routes/_terminalAdmin.terminal.admin.index'
import { Route as TerminalAdminTerminalAdminCompanyRunIdRouteImport } from './routes/_terminalAdmin.terminal.admin.$companyRunId'
import { Route as TerminalAdminTerminalAdminDigestTunerRouteImport } from './routes/_terminalAdmin.terminal.admin.digest-tuner'
import { Route as TerminalAdminTerminalAdminPolicyTunerRouteImport } from './routes/_terminalAdmin.terminal.admin.policy-tuner'
import { Route as TerminalAdminTerminalAdminRunsRouteImport } from './routes/_terminalAdmin.terminal.admin.runs'
import { Route as TerminalAdminTerminalAdminSpendRouteImport } from './routes/_terminalAdmin.terminal.admin.spend'
import { Route as SolarInstallersStateMarketSlugSplatRouteImport } from './routes/solar-installers.$state.$marketSlug.$'
import { Route as TerminalAdminTerminalAdminIdentityReviewsIndexRouteImport } from './routes/_terminalAdmin.terminal.admin.identity-reviews.index'
import { Route as TerminalAdminTerminalAdminIdentityReviewsIdentityReviewIdRouteImport } from './routes/_terminalAdmin.terminal.admin.identity-reviews.$identityReviewId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const TerminalRoute = TerminalRouteImport.update({
            id: '/_terminal',getParentRoute: () => rootRouteImport
          })
const TerminalAdminRoute = TerminalAdminRouteImport.update({
            id: '/_terminalAdmin',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MethodologyRoute = MethodologyRouteImport.update({
            id: '/methodology',path: '/methodology',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AdminAdminRoute = AdminAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AdminRoute
          })
const TerminalTerminalRoute = TerminalTerminalRouteImport.update({
            id: '/terminal',path: '/terminal',getParentRoute: () => TerminalRoute
          })
const TerminalLoginRoute = TerminalLoginRouteImport.update({
            id: '/terminal/login',path: '/terminal/login',getParentRoute: () => rootRouteImport
          })
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminAdminRoute
          })
const AdminAdminCreateUserRoute = AdminAdminCreateUserRouteImport.update({
            id: '/create-user',path: '/create-user',getParentRoute: () => AdminAdminRoute
          })
const AdminAdminMonitoringRoute = AdminAdminMonitoringRouteImport.update({
            id: '/monitoring',path: '/monitoring',getParentRoute: () => AdminAdminRoute
          })
const AdminAdminStyleRoute = AdminAdminStyleRouteImport.update({
            id: '/style',path: '/style',getParentRoute: () => AdminAdminRoute
          })
const TerminalTerminalIndexRoute = TerminalTerminalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TerminalTerminalRoute
          })
const TerminalTerminalSlugRoute = TerminalTerminalSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => TerminalTerminalRoute
          })
const TerminalTerminalDefinitionsRoute = TerminalTerminalDefinitionsRouteImport.update({
            id: '/definitions',path: '/definitions',getParentRoute: () => TerminalTerminalRoute
          })
const TerminalTerminalPolicy20Route = TerminalTerminalPolicy20RouteImport.update({
            id: '/policy-2-0',path: '/policy-2-0',getParentRoute: () => TerminalTerminalRoute
          })
const TerminalTerminalRequestsRoute = TerminalTerminalRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => TerminalTerminalRoute
          })
const CompanyLongSlugIndexRoute = CompanyLongSlugIndexRouteImport.update({
            id: '/company/$longSlug/',path: '/company/$longSlug/',getParentRoute: () => rootRouteImport
          })
const CompanyLongSlugContactRoute = CompanyLongSlugContactRouteImport.update({
            id: '/company/$longSlug/contact',path: '/company/$longSlug/contact',getParentRoute: () => rootRouteImport
          })
const TerminalAuthCallbackRoute = TerminalAuthCallbackRouteImport.update({
            id: '/terminal/auth/callback',path: '/terminal/auth/callback',getParentRoute: () => rootRouteImport
          })
const AdminAdminIndividualsIndividualIdRoute = AdminAdminIndividualsIndividualIdRouteImport.update({
            id: '/individuals/$individualId',path: '/individuals/$individualId',getParentRoute: () => AdminAdminRoute
          })
const AdminAdminMonitoringCompanyRunIdRoute = AdminAdminMonitoringCompanyRunIdRouteImport.update({
            id: '/monitoring_/$companyRunId',path: '/monitoring/$companyRunId',getParentRoute: () => AdminAdminRoute
          })
const TerminalAdminTerminalAdminIndexRoute = TerminalAdminTerminalAdminIndexRouteImport.update({
            id: '/terminal/admin/',path: '/terminal/admin/',getParentRoute: () => TerminalAdminRoute
          })
const TerminalAdminTerminalAdminCompanyRunIdRoute = TerminalAdminTerminalAdminCompanyRunIdRouteImport.update({
            id: '/terminal/admin/$companyRunId',path: '/terminal/admin/$companyRunId',getParentRoute: () => TerminalAdminRoute
          })
const TerminalAdminTerminalAdminDigestTunerRoute = TerminalAdminTerminalAdminDigestTunerRouteImport.update({
            id: '/terminal/admin/digest-tuner',path: '/terminal/admin/digest-tuner',getParentRoute: () => TerminalAdminRoute
          })
const TerminalAdminTerminalAdminPolicyTunerRoute = TerminalAdminTerminalAdminPolicyTunerRouteImport.update({
            id: '/terminal/admin/policy-tuner',path: '/terminal/admin/policy-tuner',getParentRoute: () => TerminalAdminRoute
          })
const TerminalAdminTerminalAdminRunsRoute = TerminalAdminTerminalAdminRunsRouteImport.update({
            id: '/terminal/admin/runs',path: '/terminal/admin/runs',getParentRoute: () => TerminalAdminRoute
          })
const TerminalAdminTerminalAdminSpendRoute = TerminalAdminTerminalAdminSpendRouteImport.update({
            id: '/terminal/admin/spend',path: '/terminal/admin/spend',getParentRoute: () => TerminalAdminRoute
          })
const SolarInstallersStateMarketSlugSplatRoute = SolarInstallersStateMarketSlugSplatRouteImport.update({
            id: '/solar-installers/$state/$marketSlug/$',path: '/solar-installers/$state/$marketSlug/$',getParentRoute: () => rootRouteImport
          })
const TerminalAdminTerminalAdminIdentityReviewsIndexRoute = TerminalAdminTerminalAdminIdentityReviewsIndexRouteImport.update({
            id: '/terminal/admin/identity-reviews/',path: '/terminal/admin/identity-reviews/',getParentRoute: () => TerminalAdminRoute
          })
const TerminalAdminTerminalAdminIdentityReviewsIdentityReviewIdRoute = TerminalAdminTerminalAdminIdentityReviewsIdentityReviewIdRouteImport.update({
            id: '/terminal/admin/identity-reviews/$identityReviewId',path: '/terminal/admin/identity-reviews/$identityReviewId',getParentRoute: () => TerminalAdminRoute
          })





const AdminAdminRouteChildren = {
  AdminAdminCreateUserRoute: AdminAdminCreateUserRoute,AdminAdminMonitoringRoute: AdminAdminMonitoringRoute,AdminAdminStyleRoute: AdminAdminStyleRoute,AdminAdminIndexRoute: AdminAdminIndexRoute,AdminAdminIndividualsIndividualIdRoute: AdminAdminIndividualsIndividualIdRoute,AdminAdminMonitoringCompanyRunIdRoute: AdminAdminMonitoringCompanyRunIdRoute
}

const AdminAdminRouteWithChildren = AdminAdminRoute._addFileChildren(AdminAdminRouteChildren)



const AdminRouteChildren = {
  AdminAdminRoute: AdminAdminRouteWithChildren
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const TerminalTerminalRouteChildren = {
  TerminalTerminalSlugRoute: TerminalTerminalSlugRoute,TerminalTerminalDefinitionsRoute: TerminalTerminalDefinitionsRoute,TerminalTerminalPolicy20Route: TerminalTerminalPolicy20Route,TerminalTerminalRequestsRoute: TerminalTerminalRequestsRoute,TerminalTerminalIndexRoute: TerminalTerminalIndexRoute
}

const TerminalTerminalRouteWithChildren = TerminalTerminalRoute._addFileChildren(TerminalTerminalRouteChildren)



const TerminalRouteChildren = {
  TerminalTerminalRoute: TerminalTerminalRouteWithChildren
}

const TerminalRouteWithChildren = TerminalRoute._addFileChildren(TerminalRouteChildren)




const TerminalAdminRouteChildren = {
  TerminalAdminTerminalAdminCompanyRunIdRoute: TerminalAdminTerminalAdminCompanyRunIdRoute,TerminalAdminTerminalAdminDigestTunerRoute: TerminalAdminTerminalAdminDigestTunerRoute,TerminalAdminTerminalAdminPolicyTunerRoute: TerminalAdminTerminalAdminPolicyTunerRoute,TerminalAdminTerminalAdminRunsRoute: TerminalAdminTerminalAdminRunsRoute,TerminalAdminTerminalAdminSpendRoute: TerminalAdminTerminalAdminSpendRoute,TerminalAdminTerminalAdminIndexRoute: TerminalAdminTerminalAdminIndexRoute,TerminalAdminTerminalAdminIdentityReviewsIdentityReviewIdRoute: TerminalAdminTerminalAdminIdentityReviewsIdentityReviewIdRoute,TerminalAdminTerminalAdminIdentityReviewsIndexRoute: TerminalAdminTerminalAdminIdentityReviewsIndexRoute
}

const TerminalAdminRouteWithChildren = TerminalAdminRoute._addFileChildren(TerminalAdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,TerminalRoute: TerminalRouteWithChildren,TerminalAdminRoute: TerminalAdminRouteWithChildren,LoginRoute: LoginRoute,MethodologyRoute: MethodologyRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,TerminalLoginRoute: TerminalLoginRoute,CompanyLongSlugContactRoute: CompanyLongSlugContactRoute,TerminalAuthCallbackRoute: TerminalAuthCallbackRoute,CompanyLongSlugIndexRoute: CompanyLongSlugIndexRoute,SolarInstallersStateMarketSlugSplatRoute: SolarInstallersStateMarketSlugSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)